export default __webpack_public_path__ + "static/Dots_Loop_V2-vfast-53434c286a9be0400d4518085023318e.mp4";